import React from 'react';
import { Button } from '@mui/material';
import { ExternalLink } from 'react-feather';

interface User {
  id: string;
  email: string;
  role: string;
  firstName: string;
  lastName: string;
  magicLoginLink: string;
}

export const LoginAsUserButton = ({ user }: { user: User }) => {
  if (!user) {
    return null;
  }
  return (
    <Button
      variant="outlined"
      color="primary"
      href={user.magicLoginLink}
      target="_blank"
      rel="noreferrer"
      endIcon={<ExternalLink />}
      sx={{
        flexShrink: 0,
      }}
    >
      Login as {user.role} {user.firstName} {user.lastName}
    </Button>
  );
};
